<template>
<div class="HangXachTay">
    <div class="chaomung">
    <h2 v-if="useWeb == true" style="color:red">Chúc mừng bạn đã đến với hàng xách tay Mai Phuong Tokyo</h2>
    <h5 v-else style="color:red">Chúc mừng bạn đã đến với hàng xách tay Mai Phuong Tokyo</h5>
    <h3 v-if="useWeb == true" style="color:red">(Hãy chọn mặt hàng mà bạn muốn xem)</h3>
    <p v-else style="color:red">(Hãy chọn mặt hàng mà bạn muốn xem)</p>
    </div>
    <div v-if="useWeb == true">
    <div class="tpcn">
        <h3 class="mouse underline" v-on:click="Tpcn()">Thực phẩm chức năng</h3>
    </div>
    <div class="tpcn">
        <h3 class="mouse underline">Mỹ phẩm</h3>
    </div>
    <div class="tpcn">
        <h3 class="mouse underline"  v-on:click="ShowMeVaBe()">Mẹ & bé</h3>
    </div>
    </div>
    <div v-else >
    <div class="tpcn" style="text-align: left">
        <h10 class="mouse underline slide-tpcn" v-on:click="Tpcn()">Thực phẩm chức năng</h10>
    </div>
    <div class="tpcn" style="text-align: left">
        <h10 class="mouse underline slide-tpcn">Mỹ phẩm</h10>
    </div>
    <div class="tpcn" style="text-align: left">
        <h10  class="mouse underline slide-tpcn"  v-on:click="ShowMeVaBe()">Mẹ & bé</h10>
    </div>
    </div>
    <TPCN :ValueTpcn="ValueTpcn" />
    <MeVaBe :ValueMb="ValueMB"/>
</div>
</template>

<script>

import TPCN from "@/views/HangXachTay/TPCN.vue"
import MeVaBe from "@/views/HangXachTay/MeVaBe.vue"

export default {
    name: 'HangXachTay',
    components:{
        TPCN,
        MeVaBe,

    },
    data(){
        return{
             ValueTpcn : false,
             ValueMB: false,
             ValueMP: false,
             useWeb: true,
        }
    },
    methods:{
        Tpcn(){
            this.ValueTpcn = !this.ValueTpcn;
            this.ValueMB = false;
            this.ValueMP = false;
        },
        ShowMeVaBe(){
            this.ValueMB = !this.ValueMB;
            this.ValueTpcn = false;
            this.ValueMP = false;
        },
    },
    created(){
        if(this.$device.ios || this.$device.android){
            this.useWeb = false;
        }
    }
}
</script>
<style scoped>
.HangXachTay{
    margin-top: 160px;
    margin-left: 30px;
    margin-right: 30px;
    text-align: center;
}
.tpcn{
}
.underline{
color: rgb(114, 155, 243);
text-decoration: underline;
}
.tpcn .mouse:hover{
  cursor: pointer;
   
}
.chaomung{
    background-color:rgb(225, 245, 139);
}
.slide-tpcn{
    text-align: left !important;
}


</style>